// utils.js
import {ref} from "vue";
import {useForm} from "@inertiajs/vue3";

// -------------------------------------------------------
// -------------- Tag Utilities --------------------------
// -------------------------------------------------------

export let tags = ref([ // ID is needed here or they won't be "found" when adding @TODO - find better way to handle hardcoded IDs for default tags
    { id: 99999, name: 'Summary', short_name: 'summary' },
    { id: 99998, name: 'Data', short_name: 'data' },
    { id: 99997, name: 'Charts', short_name: 'charts' },
    { id: 99996, name: 'Text-Based', short_name: 'text-based' },
    { id: 99995, name: 'Pictorial', short_name: 'pictorial' }
]);

export function setupTagsOnLoad(props) {
    if(Object.keys(props.tags).length > 0) {
        // tags.value = props.tags;
        tags.value = props.tags.filter(tag => !selectedTags.value.some(selectedTag => selectedTag.id === tag.id));
    }

    selectedTags.value.map(selectedTag => {
        const matchingTag = tags.value.find(tag => tag.id === selectedTag.id);
        return matchingTag
            ? { ...selectedTag, ...matchingTag }
            : selectedTag;
    });
}

export let selectedTags = ref([]);
export const newTagEntry = ref('');

export function selectTag(tag) {
    tags.value = tags.value.filter((el) => { return el.id !== tag.id})
    selectedTags.value.push(tag);
}

export function removeTag(tag) {
    selectedTags.value = selectedTags.value.filter((el) => { return el.id !== tag.id})
    tags.value.push(tag);
}

export function addTag() {

    let tag = newTagEntry.value;

    // check if the entry matched any tags that are available
    const matchedTagFromAvailableTags = tags.value.find(tag => {
        return tag.name.toLowerCase() === newTagEntry.value.toLowerCase();
    })

    // check if the entry matched any tags already selected
    const matchedTagFromSelectedTags = selectedTags.value.find(tag => {
        return tag.name.toLowerCase() === newTagEntry.value.toLowerCase();
    })

    if(matchedTagFromSelectedTags) { // this means the tag is already selected
        newTagEntry.value = '';
        return;
    }

    if(matchedTagFromAvailableTags) { // the means they were trying to add a tag that already exists, so select it instead
        selectTag(matchedTagFromAvailableTags);
        newTagEntry.value = '';
        return;
    }

    // let titleCase = tag.toLowerCase().split(' ').map(function(word) {
    // 	return (word.charAt(0).toUpperCase() + word.slice(1));
    // }).join(' ');

    // if you got this far, it's a brand-new tag, so we can add it
    let kebabCase = tag
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map(x => x.toLowerCase())
        .join('-');

    let newTag = { name: tag, short_name: kebabCase };

    selectedTags.value.push(newTag);
    newTagEntry.value = '';
    // tagDropdownOpen.value = false;

}

// -------------------------------------------------------
// -------------- Slide forms ----------------------------
// -------------------------------------------------------
export function createSlideForm(currentSlide, selectedCollection) {
    return useForm({
        slideID: currentSlide.value.id,
        user_id: currentSlide.value.user_id,
        slideTitle: '',
        description: '',
        collection: selectedCollection,
        tags: [],
        private: false,
        type: currentSlide.value.type,
    });
}
